<app-page-layout>
  <app-page-content>

    <div class="counters-container">
      <div class="group" *ngIf="testResultsSummary">
        <div class="title">Результаты</div>
        <div class="counters">
          <div class="counter">
            <div class="label">Всего</div>
            <div class="number">{{testResultsSummary.totalNumber}}</div>
          </div>
          <div class="counter">
            <div class="label">Завершено</div>
            <div class="number">{{testResultsSummary.finishedNumber}}</div>
          </div>
          <div class="counter">
            <div class="label">Проверено</div>
            <div class="number">{{testResultsSummary.checkedNumber}}</div>
          </div>
        </div>
      </div>
      <div class="group" *ngIf="testsSummary">
        <div class="title">Тесты</div>
        <div class="counters">
          <div class="counter">
            <div class="label">Всего</div>
            <div class="number">{{testsSummary.totalNumber}}</div>
          </div>
          <div class="counter">
            <div class="label">Активные</div>
            <div class="number">{{testsSummary.activatedNumber}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="lists-container">
      <div class="list results" *ngIf="testResultsLastFinished">
        <div class="header">
          <div class="title">Последние завершённые тесты:</div>
          <div class="count">(отображено {{testResultsLastFinished.numberOfElements}} из
            {{testResultsLastFinished.totalElements}})
          </div>
        </div>
        <ul #refEl (wheel)="onWheel($event, refEl)">
          <li *ngFor="let testResult of testResultsLastFinished.content">
            <div class="title">
              <a [routerLink]="['/tests/', testResult.test.id, 'results', testResult.id]">
                {{testResult.studentName}}
              </a>
            </div>
            <div class="subtitle">
              <a [routerLink]="['/tests/', testResult.test.id]">{{testResult.test.name}}</a>
            </div>
            <div class="time">
              <app-time-event [value]="testResult.finishDate||''"></app-time-event>
            </div>
          </li>
        </ul>
      </div>
      <div class="list tests" *ngIf="testsLastUpdated">
        <div class="header">
          <div class="title">Последние изменения:</div>
        </div>
        <ul #refEl (wheel)="onWheel($event, refEl)">
          <li *ngFor="let test of testsLastUpdated.content">
            <div class="title">
              <a [routerLink]="['/tests/', test.id]">{{test.name}}</a>
            </div>
            <div class="time">
              <app-time-event [value]="test.updateDate"></app-time-event>
            </div>
          </li>
        </ul>
      </div>
    </div>

  </app-page-content>
</app-page-layout>
